export enum RequestProductIconSize {
  Default = 'default',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  Xl = 'xl',
}

export enum ProductIconsNames {
  Obd2 = 'obd-2',
  InvisDuos = 'invis-duos',
  InvisDuosS = 'invis-duos-s',
  InvisDuos3DL = 'invis-duos-3d-l',
  OnlineSlim = 'online-slim',
  InvisDuosContainerTracker = 'invis-duos-container-tracker',
  OutcallService = 'outcall-service', // Услуга выезда
  EquipmentInstallation = 'equipment-installation', // Установка оборудования
  LSAcceptanceAndTransfer = 'ls-acceptance-and-transfer', // Приемка-передача ПЛ (leasing subject)
  EquipmentAcceptanceAndTransfer = 'equipment-acceptance-and-transfer', // Приемка-передача оборудования
  Signing = 'signing', // Подписание
  ActsSigning = 'acts-signing', // Подписание актов (неявка/отказ)
  Inspection = 'inspection', // Осмотр (ПЛ/имущества/бизнеса)
  InspectionWithBooster = 'inspection-with-booster', // Осмотр с бустером
  FuelCardsTransfer = 'fuel-cards-transfer', // Передача топливных карт
  Marking = 'marking', // Маркировка
  PassengerVehiclePreparation = 'passenger-vehicle-preparation', // Подготовка легкового ТС
  CargoVehiclePreparation = 'cargo-vehicle-preparation', // Подготовка грузового ТС/спецтехники
  LSDemonstration = 'ls-demonstration', // Демонстрация ПЛ (leasing subject)
  LSDemonstrationWithBooster = 'ls-demonstration-with-booster', // Демонстрация ПЛ с бустером (leasing subject)
  AntivandalProtectiveCase = 'antivandal-protective-case', // Чехол защитный антивандальный
  Magnet20x3 = 'magnet20x3', // Магнит 20х3
  MonitoringWithEngineBlock = 'monitoring-with-block', // Установка мониторинга с блокировкой ДВС
  MonitoringWithoutEngineBlock = 'monitoring-without-block', // Установка мониторинга без блокировки ДВС
  OnlineSpace = 'online-space',
  OnlineSpacePro = 'online-space-pro',
  GiftSet = 'gift-set',
  VehicleInspectionAndSigningDkp = 'vehicle-inspection-and-signing-dkp', // Осмотр ТС и подписание ДКП (в т.ч. СТОК)
  WarrantyOutcall = 'warranty-outcall', // Гарантийный выезд (М1–М5, последующие)
  LSAcceptanceWithoutPts = 'ls-acceptance-without-pts', // Приемка-передача ПЛ без ПТС/ПСМ
  VehicleTransfer = 'vehicle-transfer', // Приёмка-передача ТС (ФЛ, СТОК)
  VehicleInspectionAndTransfer = 'vehicle-inspection-and-transfer', // Осмотр и приёмка-передача ТС ЮЛ/ИП
  VehicleInspectionSigningAndTransfer = 'vehicle-inspection-signing-and-transfer', // Осмотр ТС, подписание ДКП и приёмка-передача ТС
  VehicleCancellation = 'vehicle-cancellation', // Отмена, фиксация недостатков по ТС
  CancellationDefectRecording = 'cancellation-defect-recording', // Отмена, фиксация недостатков
  PreparationForRepossession = 'preparation-for-repossession', // Подготовка к изъятию
  NotFoundProduct = '', // TODO сделать иконку
}

export enum ProductsIds {
  Obd2 = 3,
  InvisDuos = 2,
  InvisDuosS = 4,
  InvisDuos3DL = 10,
  OnlineSlim = 21, // X-Keeper ONLINE SLIM
  InvisDuosContainerTracker = 22,
  OutcallService = 1, // Услуга выезда
  EquipmentInstallation = 5, // Установка оборудования
  LSAcceptanceAndTransfer = 6, // Приемка-передача ПЛ (leasing subject)
  EquipmentAcceptanceAndTransfer = 13, // Приемка-передача оборудования
  Signing = 7, // Подписание
  ActsSigning = 11, // Подписание актов (неявка/отказ)
  Inspection = 8, // Осмотр (ПЛ/имущества/бизнеса)
  InspectionWithBooster = 14, // Осмотр с бустером
  FuelCardsTransfer = 9, // Передача топливных карт
  Marking = 12, // Маркировка
  PassengerVehiclePreparation = 15, // Подготовка легкового ТС
  CargoVehiclePreparation = 16, // Подготовка грузового ТС/спецтехники
  LSDemonstration = 17, // Демонстрация ПЛ (leasing subject)
  LSDemonstrationWithBooster = 18, // Демонстрация ПЛ с бустером (leasing subject)
  AntivandalProtectiveCase = 19, // Чехол защитный антивандальный
  Magnet20x3 = 20, // Магнит 20х3
  MonitoringWithoutEngineBlock = 35, // Установка мониторинга без блокировки ДВС
  MonitoringWithEngineBlock = 36, // Установка мониторинга с блокировкой ДВС
  OnlineSpace = 38,
  WarrantyOutcallM1 = 23, // Гарантийный выезд (М1)
  WarrantyOutcall = 24, // Гарантийный выезд
  WarrantyOutcallM2 = 29, // Гарантийный выезд (М2)
  WarrantyOutcallM3 = 30, // Гарантийный выезд (М3)
  WarrantyOutcallM4 = 31, // Гарантийный выезд (М4)
  WarrantyOutcallM5 = 32, // Гарантийный выезд (М5)
  WarrantyOutcallSubsequent = 33, // Гарантийный выезд (последующие)
  LSAcceptanceWithoutPts = 34, // Приемка-передача ПЛ без ПТС/ПСМ
  GiftSet = 39, // Подарочный набор
  VehicleInspectionSigningAndTransfer = 40, // Осмотр ТС, подписание ДКП и приёмка-передача ТС
  VehicleInspectionSigningAndTransferCancellation = 41, // Осмотр ТС, подписание ДКП и приёмка-передача ТС. Отмена, фиксация недостатков
  VehicleTransferFl = 42, // Приёмка-передача ТС ФЛ
  VehicleTransferFlCancellation = 43, // Приёмка-передача ТС ФЛ. Отмена, фиксация недостатков
  VehicleInspectionAndTransferYulIp = 44, // Осмотр и Приёмка-передача ТС ЮЛ/ИП
  VehicleInspectionAndTransferYulCancellation = 45, // Осмотр и Приёмка-передача ТС ЮЛ. Отмена, фиксация недостатков
  VehicleTransferStock = 46, // Приёмка-передача ТС СТОК
  VehicleTransferStockCancellation = 47, // Приёмка-передача ТС СТОК. Отмена, Расторжение ДКП
  VehicleInspectionAndSigningDkpStock = 48, // Осмотр ТС и подписание ДКП СТОК
  VehicleInspectionAndSigningDkp = 49, // Осмотр ТС и подписание ДКП
  VehicleInspectionAndSigningDkpCancellation = 50, // Осмотр ТС и подписание ДКП. Отмена, фиксация недостатков
  CancellationDefectRecording = 51, // Отмена, фиксация недостатков
  PreparationForRepossession = 52, // Подготовка к изъятию
  OnlineSpacePro = 53,
}
